import axios, { AxiosError } from "axios";
import {
  APIError,
  ArtistUserGroups,
  GetRecentlyUpdatedArtistsResponse,
  ProcessStatus,
  UserArtistPair,
} from "./type";
import { Row } from "../../../../types/bigQuery.type";

export const formatLogData = (logDataList?: Row[]): UserArtistPair[] => {
  if (!logDataList || !logDataList.length) return [];

  return logDataList.reduce<UserArtistPair[]>((acc, data) => {
    // 필요한 데이터가 있는지 확인
    if (!data.f?.[0]?.v || !data.f?.[1]?.v) return acc;

    const userId = data.f[0].v.toString();
    const artistId = data.f[1].v.toString();

    // null이 아닌 경우만 포함
    if (userId && artistId) {
      acc.push({ userId, artistId });
    }

    return acc;
  }, []);
};

export const groupUsersByArtist = (
  pairs: UserArtistPair[]
): ArtistUserGroups => {
  return pairs.reduce((groups: ArtistUserGroups, pair) => {
    const { artistId, userId } = pair;
    if (!groups[artistId]) {
      groups[artistId] = [];
    }
    if (!groups[artistId].includes(userId)) {
      groups[artistId].push(userId);
    }
    return groups;
  }, {});
};

// API URL을 상수로 정의
const API_BASE_URL = "https://asia-northeast3-homebrew-prod.cloudfunctions.net";

export const fetchRecentlyUpdatedArtists =
  async (): Promise<GetRecentlyUpdatedArtistsResponse> => {
    try {
      const response = await axios.get<GetRecentlyUpdatedArtistsResponse>(
        `${API_BASE_URL}/getRecentlyUpdatedArtists`,
        {
          headers: {
            "Content-Type": "application/json",
          },
          timeout: 10000, // 10초 타임아웃 설정
        }
      );

      // 응답 데이터 유효성 검사
      const { data, timestamp, periodStart } = response.data;
      if (!data || !Array.isArray(data) || !timestamp || !periodStart) {
        throw new APIError("Invalid response format from server");
      }

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError;
        if (axiosError.response) {
          // 서버가 응답을 반환한 경우 (4xx, 5xx 에러)
          throw new APIError(
            `Server error: ${axiosError.response.statusText}`,
            axiosError.response.status,
            error
          );
        } else if (axiosError.request) {
          // 요청은 보냈지만 응답을 받지 못한 경우
          throw new APIError(
            "No response received from server",
            undefined,
            error
          );
        } else {
          // 요청 설정 중 에러가 발생한 경우
          throw new APIError("Failed to send request", undefined, error);
        }
      }
      // 기타 에러 처리
      throw new APIError("Unexpected error occurred", undefined, error);
    }
  };

export const getStatusColor = (
  status: ProcessStatus[keyof Omit<ProcessStatus, "message">]
) => {
  switch (status) {
    case "success":
      return "#28a745";
    case "error":
      return "#dc3545";
    case "loading":
      return "#007bff";
    default:
      return "#6c757d";
  }
};
